export function langSwitcher() {
    const langSwitch = $(".language-switcher");
    langSwitch.on("click", function () {
        if(!$(".main-nav").hasClass("active")) {
            langSwitch.toggleClass("active");
        }
    });
    $(document).on("click", function (event) {
        if(!$(event.target).closest(".language-switcher").length) {
            langSwitch.removeClass("active");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/lang-switcher.js